<template>
  <!-- Custom Dialog Template -->
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'400px'"
    :classDialog="'listMoreDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #header>
      <h3 class="dialogTitle">{{ computedTitle }}</h3>
    </template>

    <template #body>
      <div class="coordinator-list">
        <div
          v-for="coordinator in coordinators"
          :key="coordinator.id"
          class="coordinator-item flex-row align-items-center"
        >
          <i
            v-if="!coordinator.url"
            style="font-size: 28px; margin-right: 10px"
            class="cellIcon color__silver fas fa-user-circle"
          ></i>
          <div class="text-item">
            {{ coordinator.fullName }} ({{ coordinator.positionName }} - {{ coordinator.deptName }})
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="flex-row flex__center form-button__action margin-top-10">
        <el-button
          type="info"
          size="mini"
          class="btn__cancel btn-none__border"
          @click="cancel"
        >
          <span class="flex-row flex__center">
            <i class="far fa-times-circle font-size__medium"></i>
            &nbsp;&nbsp;Đóng
          </span>
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
export default {
  name: "modal-list-more",
  components: {
    CustomDialog: () => import("./custom-dialog.vue"),
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Danh sách",
    },
    coordinators: {
      type: Array,
      default: () => [],
    },
    type:{
      type: String,
      default: "approver",
    }
  },
  computed: {
    computedTitle() {
      return this.type === 'approver' ? 'Người duyệt' : 'Người được thông báo';
    },
  },
  methods: {
    cancel() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped>
.dialogTitle {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.coordinator-list {
  max-height: 300px;
  overflow-y: auto;
}

.coordinator-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.text-item{
  word-break: keep-all;
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/common/modal-list-more.vue